export const DONATE_SHOW_TOGGLE_LOADING = 'DONATE_SHOW_TOGGLE_LOADING'
